import React, { forwardRef, useEffect } from "react";
import "./FlangeChecklist.css";

const FlangeChecklist = forwardRef((props, ref) => {
  useEffect(() => {
    console.log("✅ FlangeChecklist mounted");
  }, []);

  console.log("📦 FlangeChecklist received ref:", ref);

  const tableData = [
    {
      nozzle: "B7",
      boltMaterial: "B7",
      boltSize: '1 1/4"',
      flangeSize: '24"',
      rating: "150#",
      torqueValue: 1032,
      pass1: 309.6,
      pass2: 619.2,
      pass3: 1032,
      finalCheck: 1032,
    },
    // You can add more rows for testing
  ];

  return (
    <div ref={ref} className="checklist-container">
      <div className="header">
        <h2>JECON ENGINEERS PVT LTD</h2>
        <p>VADODARA, GUJARAT, INDIA</p>
        <h3>Torquing / Bolt Tensioning Checklist (TAR-2024)</h3>
        <p>(Attachment - 1.4)</p>
      </div>

      <div className="equipment-section">
        <div className="equipment-detail">
          <span>SAP WORK ORDER NUMBER / JOB ID</span>
        </div>
        <div className="equipment-detail">
          <span>EQUIPMENT / LINE NUMBER: </span>
          <span>A1</span>
        </div>
        <div className="equipment-detail">
          <span>UNIT NAME: </span>
          <span>115 HYDROCRACKER</span>
        </div>
        <div className="date-section">
          <span>DATE:</span>
        </div>
      </div>

      <div className="table-section">
        <table>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Nozzle No / Spade Tag No</th>
              <th>Bolt Material</th>
              <th>Bolt Size</th>
              <th>Flange Size</th>
              <th>Rating</th>
              <th>Torque Value in Nm</th>
              <th>Pass1 30%</th>
              <th>Pass2 60%</th>
              <th>Pass3 100%</th>
              <th>Final Check</th>
              <th>GAP B/W Flange Faces</th>
              <th>Torquing Tag No</th>
              <th>ACC</th>
              <th>NOT ACC</th>
              <th>Date</th>
              <th>Tech. Sign</th>
              <th>Remark</th>
            </tr>
          </thead>
          <tbody>
            {tableData.map((row, idx) => (
              <tr key={idx}>
                <td>{idx + 1}</td>
                <td>{row.nozzle}</td>
                <td>{row.boltMaterial}</td>
                <td>{row.boltSize}</td>
                <td>{row.flangeSize}</td>
                <td>{row.rating}</td>
                <td>{row.torqueValue}</td>
                <td>{row.pass1}</td>
                <td>{row.pass2}</td>
                <td>{row.pass3}</td>
                <td>{row.finalCheck}</td>
                <td></td>
                <td></td>
                <td><input type="checkbox" /></td>
                <td><input type="checkbox" /></td>
                <td></td>
                <td></td>
                <td></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="footer-section">
        <p>ACC = Accepted, Not ACC = Not Accepted</p>
        <p className="verified">Torquing Value & Sequence Verified</p>

        <div className="signatures">
          <div className="contractor">
            <p><strong>CONTRACTOR GEMINI</strong></p>
            <p>SIGN: ____________</p>
            <p>NAME: ____________</p>
            <p>DESIGNATION: ____________</p>
            <p>DATE & TIME: ____________</p>
          </div>
          <div className="supervisor">
            <p><strong>JECON MECHANICAL SUPERVISOR</strong></p>
            <p>SIGN: ____________</p>
            <p>NAME: ____________</p>
            <p>DESIGNATION: ____________</p>
            <p>DATE & TIME: ____________</p>
          </div>
        </div>
      </div>
    </div>
  );
});

export default FlangeChecklist;
